<script lang="ts">
  import { onMount } from "svelte";
  import { Router } from "svelte-navigator";
  import {
    theme,
    INTERNAL_ACCESS_KEY,
    headTitleStore,
  } from "./app/store/store-ui";
  import AppRoutes from "./AppRoutes.svelte";
  import Tailwind from "./styles/tailwind.svelte";
  import { applyTheme } from "./styles/themes/utils";

  theme.subscribe((currentTheme) => {
    applyTheme(currentTheme);
  });

  if (window) {
    window.history.pushState = new Proxy(window.history.pushState, {
      apply(target, thisArg, argumentsList) {
        Reflect.apply(target, thisArg, argumentsList);
        document.body.scrollTo({
          top: 0,
          left: 0,
        });
        if (
          window.handleUiPageRedirect &&
          typeof window.handleUiPageRedirect === "function"
        ) {
          window.handleUiPageRedirect();
        }
      },
    });
  }

  onMount(() => {
    const params = new URLSearchParams(document.location.search);
    const token = params.get(INTERNAL_ACCESS_KEY);
    if (token) {
      localStorage.setItem(INTERNAL_ACCESS_KEY, token);
    }
  });

  $: headTitle = $headTitleStore;
</script>

<svelte:head>
  <title>Datadocs {headTitle ? `- ${headTitle}` : ""}</title>
</svelte:head>

<Tailwind />

<main>
  <Router primary={false}>
    <div id="appRoot">
      <AppRoutes />
    </div>
  </Router>
</main>
